module.exports = __webpack_public_path__ + "static/media/ebt.0d019ce3.svg";